<template>
	<div class="d-flex flex-wrap">
		<v-col cols="12" class="px-0 pb-0">
			<v-row class="ml-0 mt-0 body-transaction-product body-transaction-product-sm">
				<template v-if="loading">
					<v-col cols="6" sm="4" md="3" lg="2" xl="2" class="pl-0 pb-0" v-for="i in 6" :key="i">
						<v-card class="pa-3 elevation-0 rounded-xl hover-shadow h-100 w-100 custom-skeleton">
							<v-skeleton-loader width="100%" height="150px" type="image" class="rounded-xl"></v-skeleton-loader>
							<v-skeleton-loader width="50%" type="text" class="mt-5"></v-skeleton-loader>
							<v-skeleton-loader width="100%" type="text" class="mt-2"></v-skeleton-loader>
							<v-skeleton-loader width="50%" type="text" class="mt-2"></v-skeleton-loader>
							<v-skeleton-loader width="100%" type="heading" class="mt-4 rounded-xl"></v-skeleton-loader>
							<v-skeleton-loader width="100%" type="heading" class="mt-4 rounded-xl"></v-skeleton-loader>
						</v-card>
					</v-col>
				</template>
				<template v-if="!loading">
					<v-col cols="6" sm="3" md="3" lg="2" xl="2" class="pl-0 pt-0 d-flex flex-wrap" v-for="product in productList" :key="product.product_id+'b'">
						<v-card class="pa-3 elevation-0 rounded-xl hover-shadow h-100">
							<div class="btn-detail">
								<v-btn depressed x-small fab class="bg-primary" @click="showModalDetail(product.product_code)">
									<v-icon color="white">mdi-information-variant</v-icon>
								</v-btn>
							</div>
							<v-img height="160px" class="rounded-xl" :src="product.product_image ? product.product_image : require('/public/assets/image/user-pict.jpg')"></v-img>
							<div class="pt-3">
								<v-tooltip bottom>
									<template v-slot:activator="{ on, attrs }">
										<div class="font-size-10 product-name cl-dark-green" v-bind="attrs" v-on="on">{{ product.product_name }}</div>
									</template>
									<span>{{ product.product_name }}</span>
								</v-tooltip>
								<div class="font-size-12 cl-primary">{{ product.product_price | toRupiah }}</div>
								<div class="font-size-9 cl-grey text-decoration-line-through" v-if="product.product_discount > 0">{{ product.product_charge_price | toRupiah }}</div>
								<div class="pt-1 font-size-9 cl-grey">Berat {{ product.product_weight | toKg }}</div>
							</div>
							<div class="checked-input mt-2 mb-1 rounded-lg" :class="(!product.product_checked) ? 'grey lighten-4' : 'red lighten-5'">
								<v-col cols="12" class="pa-0 d-flex">
									<v-checkbox hide-details class="mt-0 pt-0 mr-0 font-size-10" :class="{'green--text' : product.product_checked}" label="Beli Produk" on-icon="mdi-check-circle" off-icon="mdi-checkbox-blank-circle-outline" :disabled="product.product_qty == 0" v-model="product.product_checked" @click="checkBuy(product, product.product_id)"></v-checkbox>
								</v-col>
							</div>
							<v-row class="py-2 justify-space-between align-center">
								<v-col cols="3" sm="3" md="3" xl="3" class="pr-0">
									<v-btn text x-small :disabled="!product.product_checked" @click="decQty(product)" class="px-0" style="min-width: 33px;">
										<v-icon color="warning">mdi-minus-circle-outline</v-icon>
									</v-btn>
								</v-col>
								<v-col cols="6" sm="6" md="6" xl="6" class="">
									<div class="">
										<v-text-field class="input-text-center" dense hide-details="auto" v-model="product.product_quantity" :disabled="!product.product_checked" @keypress="onlyNumber" @keyup="addTotal(product)" @paste.prevent></v-text-field>
									</div>
								</v-col>
								<v-col cols="3" sm="3" md="3" xl="3" class="pl-0">
									<v-btn text x-small :disabled="!product.product_checked" @click="addQty(product)" class="px-0 flex-shrink-0" style="min-width: 33px;">
										<v-icon color="primary">mdi-plus-circle-outline</v-icon>
									</v-btn>
								</v-col>
							</v-row>
						</v-card>
					</v-col>
				</template>
			</v-row>
			<div class="footer-transaction-product rounded-xl">
				<div class="d-flex flex-wrap">
					<v-col cols="12" sm="6" class="py-0">
						<div class="font-size-xs-10 font-size-11 product-name">Total produk <b>{{ sumQty | toNumber }}</b></div>
						<div class="font-size-13 cl-primary">{{ sumTotal | toRupiah }}</div>
					</v-col>
					<v-col cols="12" sm="6" class="pb-0 px-0 pa-sm-0 text-right my-auto">
						<v-btn large width="120" depressed color="primary" class="ml-2 rounded-pill" :disabled="firstData.length == 0" @click="nextStep">
							<span class="pr-2 text-capitalize font-size-xs-10 font-size-11 font-weight-bold">Lanjut</span>
							<v-icon>mdi-arrow-right</v-icon>
						</v-btn>
					</v-col>
				</div>
			</div>
		</v-col>
		<ModalDetail ref="modalDetail"></ModalDetail>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalDetail from './components/ModalDetail';

export default {
	components: {
		ModalDetail
	},
	data() {
		return {
			firstData: [],
			inputSearch: '',
			loading: false,
			msgBack: 'Jika kembali Anda harus mengulangi proses Input Repeat Order. Yakin ingin kembali?',
		}
	},
	computed: {
		...mapState('produk', ['productList']),

		sumQty() {
			let qty = 0
			this.firstData.forEach((el) => {
				qty += parseInt(el.product_quantity)
			})
			return qty
		},
		sumTotal() {
			let total = 0
			this.firstData.forEach((el) => {
				total += parseInt(el.product_total)
			})
			return total
		},
	},
	methods: {
		...mapActions('produk', ['getProductList', 'getProductDetail']),

		getData() {
			this.loading = true
			this.getProductList({limit: 1000, page: 1}).then(() => {
				this.loading = false
			})
		},
		showModalDetail(code) {
			this.$refs.modalDetail.modalShow()
			this.getProductDetail({ code: code })
		},
		checkBuy(product, id) {
			if (product.product_checked == true) {
				this.firstData.push(product)
			} else {
				this.firstData = this.firstData.filter(function(item) {
					return item.product_id !== id
				})
			}
		},
		addQty(product) {
			if (product.product_quantity >= 0) {
				product.product_quantity++
				product.product_total = product.product_quantity * product.product_price
			}
			if (product.product_quantity > 1000) {
				product.product_quantity = 1000
				product.product_total = product.product_quantity * product.product_price
			}
		},
		decQty(product) {
			if (product.product_quantity > 1) {
				product.product_quantity--
				product.product_total = product.product_quantity * product.product_price
			}
		},
		addTotal(product) {
			if (parseInt(product.product_quantity) > 1000) {
				product.product_quantity = 1000
			} else if (parseInt(product.product_quantity) <= 0) {
				product.product_quantity = 1
			} else if (product.product_quantity == '') {
				product.product_quantity = 1
			}
			product.product_total = product.product_quantity * product.product_price
		},
		nextStep() {
			this.firstData.forEach((el, i) => {
				if (el.product_quantity == '') {
					this.firstData[i].product_quantity = 1
				}
			})
			this.$emit('action', this.firstData)
		}
	},
	created() {
		this.getData()
	},
};
</script>